const apiKeys = {
    openWeatherAPI: '21bf8fc0f38f8a44fabdc8fbca1f13bc',
    openCageAPI: '520ef9e404bd466a8fec5853300d5bfe'
};

export default apiKeys;
